import paint from '../../assets/icons/Icons.jpg';
import box from '../../assets/icons/box.png';
import gateway from '../../assets/icons/database.png';

export const advantages = [
	{
		description: 'Continuous updates to ensure compliance and future proofing of new technology'
	},
	{
		description: 'Easy integration with existing in-house systems'
	},
	{
		description: 'System operated and monitored by the local SWIFT Experts'
	}
];

export const advantagestow = [
	{
		description: 'Transfer investments risk into operation '
	},
	{
		description: 'Improved efficiency at lower costs'
	},
	{
		description: 'Guaranteed quality and level of service SLA'
	},
	{
		description: 'Low up-front costs'
	},
	{
		description: 'Redundant systems for immediate backup and recovery '
	},
	{
		description: 'High-level end-to-end security'
	},
	{
		description: 'Scalable service for processing from few messages to thousands'
	},
	{
		description: 'Availability of experts from many IT areas'
	}
];
